import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { SliderPageWrapper } from "../../layout/sliderPageWrapper/SliderPageWrapper";

import classes from "./PaymentDetail.module.scss";

export const PaymentDetail = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const tabsRef: any = useRef();
  const { t } = useTranslation(["payment"]);
  useEffect(() => {
    const temp = tabsRef.current;
    temp.addEventListener("MDCTabBar:activated", (e: any) => {
      setSelectedTab(e.detail.index);
    });
    return () => {
      temp.removeEventListener("MDCTabBar:activated", (e: any) => {
        setSelectedTab(e.detail.index);
      });
    };
  }, []);

  return (
    <SliderPageWrapper headerTitle={t("payment:payment_details")}>
      <div className={classes.headWrapper}>
        <div className={classes.ModuleHeadWrapper}>
          <ft-tab-bar ref={tabsRef}>
            <ft-tab label={t("payment:details")}></ft-tab>
          </ft-tab-bar>
        </div>
      </div>
      <div className={classes.ModuleWrapper}>
        {selectedTab === 0 ? "Detail" : "hghj"}
      </div>
    </SliderPageWrapper>
  );
};
